export default function formatCurrencyAsUsd(number) {
  const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });
  return currencyFormatter.format(Number(`${number}`.replace(/[^0-9.-]+/g, '')));
}
